import LightbulbIcon from "@mui/icons-material/Lightbulb";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface IListStateIconOpportunityProps {
  noMargin?: boolean;
  tooltip?: string;
  color?: string;
  customColor?: string;
}

export const ListStateIconOpportunity = ({
    noMargin,
    tooltip,
    color,
    customColor,
}: IListStateIconOpportunityProps) => (
    <ListStateIcon
        color={color}
        customColor={customColor}
        noMargin={noMargin}
        tooltip={tooltip}
        icon={LightbulbIcon}
    />
);
